export default "__VITE_ASSET__07c5e330__"